<template>
    <div>
        <div>
            <div class="content">
                <div class="left"></div>
                <div class="title">营业执照</div>
            </div>

            <div class="imgDiv" @click="open('1')">
                <img :src="agencyImages.license">
                <div class="desc">公司营业执照</div>
            </div>
        </div>

        <div>
            <div class="content">
                <div class="left"></div>
                <div class="title">经营环境</div>
            </div>

            <div style="display: flex;">
                <div class="imgDiv" @click="open('2')">
                    <img :src="agencyImages.doorhead">
                    <div class="desc">公司门头照片</div>
                </div>
                <div class="imgDiv" @click="open('3')">
                    <img :src="agencyImages.environment">
                    <div class="desc">公司经营环境</div>
                </div>
            </div>
        </div>

        <van-popup v-model:show="toastShow">
            <div class="toast">
                <img :src="image">
                <div class="watermark">仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示仅展示</div>
            </div>
        </van-popup>

        <Loading :isShow="isShowLoading"></Loading>

    </div>
</template>

<script>
    import Loading from '@/components/loading';
    export default {
        name: "agencyImages",
        components:{
          Loading
        },
        data(){
            return{
                isShowLoading:false,
                toastShow:false,
                agencyId:0,
                agencyImages:{},
                image:""
            }
        },created(){
            this.agencyId = this.$route.query.agencyId;
            this.getAgencyImages();
        },methods:{
            getAgencyImages() {
                this.isShowLoading=true;
                let param = {
                    agencyId: this.agencyId,
                };
                this.$get("/app/api/v1/order/agency/images", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.isShowLoading=false;
                            this.agencyImages=res.data;
                        } else {
                            this.isShowLoading=false;
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {
                        this.isShowLoading=false;
                    });
            },open(param){
                if(param==1){
                    this.image=this.agencyImages.license;
                }else if(param==2){
                    this.image=this.agencyImages.doorhead;
                }else if(param==3){
                    this.image=this.agencyImages.environment;
                }
                this.toastShow=true;
            },

        }
    }
</script>

<style scoped>
    *{
        font-family: PingFangSC-Medium, PingFang SC;
    }

    .content{
        display: flex;
        align-items: center;
        border-bottom: 1px solid #EEEEEE;
        padding: 0.1rem;
    }

    .content .left{
        width: 3px;
        height: 0.15rem;
        background: #486CFF;
        margin-right: 0.05rem;
    }

    .content .title{
        font-size: 0.14rem;
        font-weight: 500;
        color: #333333;
    }

    .imgDiv{
        width: 1.1rem;
        height: 0.78rem;
        margin: 0.2rem auto;
    }

    .imgDiv img{
        width: 100%;
        height: 100%;
    }

    .imgDiv .desc{
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        text-align: center;
    }

    .toast{
        position: relative;
    }

    .toast img{
        width: 100%;
        height: 100%;
    }

    .toast .watermark{
        font-family: PingFangSC-Regular, PingFang SC;
        position: absolute;
        z-index: 100;
        left:0%;
        right:0%;
        top:0%;
        bottom: 0%;
        line-height: 0.3rem;
        font-weight: 400;
        color: #999999;
        border: 1px solid blue;
        overflow: hidden;
        font-size: 15px;
        opacity: 0.2;
    }


</style>
